import { PermissionsTranslation } from 'locales/de/pages/Access-Handler/permissions';

const en: PermissionsTranslation = {
  title: 'Permission',
  createPermission: 'Create Permission',
  model: {
    service: 'Service',
    feature: 'Feature',
    scope: 'Scope',
    result: 'Result',
    roles: 'Roles'
  },
  deleteConfirm: {
    title: 'Really delete?',
    message: 'Are you sure you want to delete this permission?'
  },
  alerts: {
    saveFailed: 'The permission could not be saved.',
    saveSuccess: 'The permission was successfully saved.',
    deleteFailed: 'The permission could not be deleted.',
    deleteSuccess: 'The permission was successfully deleted.'
  }
};

export default en;
